import { render, staticRenderFns } from "./AddPromotionModal.vue?vue&type=template&id=cacb00b2&scoped=true"
import script from "./AddPromotionModal.vue?vue&type=script&lang=js"
export * from "./AddPromotionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacb00b2",
  null
  
)

export default component.exports